import { 
    ORDER_CREATE_FAIL,
    ORDER_CREATE_REQUEST,
    ORDER_CREATE_SUCCESS,
    ORDER_DETAILS_REQUEST, 
    ORDER_DETAILS_FAIL,
    ORDER_DETAILS_SUCCESS, 
    ORDER_PAY_RESET, 
    ORDER_PAY_FAIL, 
    ORDER_PAY_SUCCESS, 
    ORDER_PAY_REQUEST, 
    ORDER_LIST_MY_FAIL, 
    ORDER_LIST_MY_SUCCESS, 
    ORDER_LIST_MY_REQUEST, 
    ORDER_LIST_MY_RESET, 
    ORDER_LIST_REQUEST, 
    ORDER_LIST_SUCCESS, 
    ORDER_LIST_FAIL, 
    ORDER_DELIVER_REQUEST, 
    ORDER_DELIVER_SUCCESS, 
    ORDER_DELIVER_FAIL, 
    TOGGLE_CREATE_ORDER_MODAL,
    ORDER_MARK_AS_READ_FAIL,
    ORDER_MARK_AS_READ_SUCCESS,
    ORDER_MARK_AS_READ_REQUEST,
    ORDER_DELETE_REQUEST,
    ORDER_DELETE_SUCCESS,
    ORDER_DELETE_FAIL,
    ORDER_DETAIL_MODAL_TOGGLE
} from "../constants/orderConstants";

export const CreateOrderReducers = (state = {} , action) => {
    switch (action.type) {
        case TOGGLE_CREATE_ORDER_MODAL:
            const toggled = !state.showCreateOrderModal
            return {
                ...state,
                showCreateOrderModal: toggled,
                order: !toggled ? {} : action.payload
            }
        case ORDER_CREATE_REQUEST:
            return {
                ...state,
                loading : true
            }
        case ORDER_CREATE_SUCCESS:
            return {
                ...state,
                loading : false,
                success: true,
                order: {},
                showCreateOrderModal: false
            }
        case ORDER_CREATE_FAIL :
            return{
                ...state,
                loading : false,
                error: action.payload,
                order: {},
                showCreateOrderModal: false
            }
        default:
            return state
    }
}
export const OrderDetailsreducer = (state = {loading : true, orderItems : [],shippingAddress: {}} , action) => {
    switch (action.type) {
        case ORDER_DETAIL_MODAL_TOGGLE:
            return {
                ...state,
                showOrderDetailModal: !state.showOrderDetailModal,
                order: !state.showOrderDetailModal ? action.payload : {},
                orderItems: {}
            }
        case ORDER_DETAILS_REQUEST:
            return {
                ...state,
                loading : true,
            }
        case ORDER_DETAILS_SUCCESS:
            return {
                ...state,
                loading : false,
                orderItems: action.payload
            }
        case ORDER_DETAILS_FAIL :
            return{
                ...state,
                loading : false,
                error : action.payload,
                orderItems: {},
                order: {}
            }
        default:
            return state
    }
}
export const OrderPayreducer = (state = {} , action) => {
    switch (action.type) {
        case ORDER_PAY_REQUEST:
            return {
                loading : true,
            }
        case ORDER_PAY_SUCCESS:
            return {
                loading : false,
                success : true
            }
        case ORDER_PAY_FAIL :
            return{
                loading : false,
                error : action.payload,

            }
        case ORDER_PAY_RESET:
            return{}
        default:
            return state
    }
}

export const OrderDeliverreducer = (state = {} , action) => {
    switch (action.type) {
        case ORDER_DELIVER_REQUEST:
            return {
                loading : true,
            }
        case ORDER_DELIVER_SUCCESS:
            return {
                loading : false,
                success : true
            }
        case ORDER_DELIVER_FAIL :
            return{
                loading : false,
                error : action.payload,

            }
        case ORDER_PAY_RESET:
            return{}
        default:
            return state
    }
}

export const OrderListMyreducer = (state = {orders : []} , action) => {
    switch (action.type) {
        case ORDER_LIST_MY_REQUEST:
            return {
                loading : true,
            }
        case ORDER_LIST_MY_SUCCESS:
            return {
                loading : false,
                orders : action.payload
            }
        case ORDER_LIST_MY_FAIL :
            return{
                loading : false,
                error : action.payload,

            }
        case ORDER_LIST_MY_RESET :
            return{orders : []}    
        default:
            return state
    }
}

export const OrderListreducer = (state = {orders : []} , action) => {
    switch (action.type) {
        case ORDER_LIST_REQUEST:
            return {
                loading : true,
            }
        case ORDER_LIST_SUCCESS:
            return {
                loading: false,
                orders: action.payload
            }
        case ORDER_LIST_FAIL :
            return{
                loading : false,
                error: action.payload,
            }   
        case ORDER_MARK_AS_READ_FAIL :
            return{
                loading : false,
                error: action.payload,
            }
        case ORDER_MARK_AS_READ_REQUEST :
            return{
                loading : true,
            }
        case ORDER_MARK_AS_READ_SUCCESS :
            return{
                loading : false,
                orders: action.payload
            }
        case ORDER_DELETE_REQUEST :
            return{
                loading : true,
            }
        case ORDER_DELETE_SUCCESS :
            return{
                loading : false,
                orders: action.payload
            }
        case ORDER_DELETE_FAIL :
            return{
                loading : false,
                error: action.payload,
            }
        default:
            return state
    }
}